import {
  FeatureAppConfiguration,
  FeatureappServiceOptions,
} from '../featureapp-service';

export const createObservable = (
  value: FeatureappServiceOptions,
  accessListener?: (propertyValue: FeatureAppConfiguration) => void,
): FeatureappServiceOptions => {
  if (accessListener && typeof Proxy !== 'undefined') {
    const handler = {
      get(
        target: FeatureappServiceOptions,
        prop: string,
      ): FeatureAppConfiguration {
        accessListener(target[prop]);

        return target[prop];
      },
    };

    return new Proxy(value, handler);
  }

  return value;
};
